module.exports = __webpack_public_path__ + "static/media/info.718384bb.svg";